module.exports = __webpack_public_path__ + "img/zishuyanwobing.02e44ad0.jpg";